module.exports = __webpack_public_path__ + "assets/74764a308044940c77d26406d27a7949.png";